import { Button } from 'components/common';
import { CLEVER_SSO_URL } from 'config/settings';
import styled from 'styled-components';

const CleverLoginButton = ({ ...props }) => {
  return (
    <StyledButton
      outline
      onClick={() => window.open(CLEVER_SSO_URL, '_self')}
      {...props}>
      <img
        src="https://home-content.eedi.com/web/clever-logo-c.PNG"
        alt="Clever Logo"
      />
      Sign in with Clever
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  width: 100%;
  padding: 0.1rem;
  :hover {
    background: #fff;
  }
  min-height: 40px;
`;

export default CleverLoginButton;
